import api from '../utils/apiClient';

export const REBSTOCK_BOT_SLUG = 'rebstockbot';
export const AIAPPSPACE_BOT_SLUG = 'aiappspacebot';

const ACCEPTED_TYPES = [
  'application/pdf',
  'text/plain',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

/**
 * @param {{ appSlug: string; content: string; document: File | null }} payload
 * @returns {Promise<{ success: boolean; message: string; entry?: object }>}
 */
export async function submitLearning(payload) {
  if (!payload.appSlug?.trim()) throw new Error('Please select an app.');

  const hasText = Boolean(payload.content?.trim());
  const hasFile = Boolean(payload.document);
  if (!hasText && !hasFile) {
    throw new Error('Please enter learning content or upload a document.');
  }

  const formData = new FormData();
  if (payload.content?.trim()) formData.append('content', payload.content.trim());
  if (payload.document) formData.append('document', payload.document);

  const res = await api.post(
    `/api/admin/apps/${payload.appSlug}/learning`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return res.data;
}

/** @param {File} file */
export function validateLearningDocument(file) {
  if (!file) return 'No file selected.';
  if (!ACCEPTED_TYPES.includes(file.type)) {
    return 'Supported formats: PDF, TXT, DOC, DOCX.';
  }
  if (file.size > 10 * 1024 * 1024) {
    return 'File must be 10MB or smaller.';
  }
  return null;
}
